import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  max-width: 680px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SVG = styled.svg`
  height: 100%;
  width: 100%;
`;
